import type { RouteRecordRaw } from 'vue-router';

import { EnumRoutes } from '@/helpers/enums/routes.enum';
import LandingLayOut from '@/layout/AuthLayout.vue';

export const landingPageRoutes: Array<RouteRecordRaw> = [
  {
    path: '',
    name: 'Main Layout',
    component: LandingLayOut,
    redirect:
      import.meta.env.VITE_ALLOW_LANDING === 'false'
        ? EnumRoutes.lms.root.path
        : EnumRoutes.landing.root.path,
    meta: EnumRoutes.landing.root.meta,
    children: [
      {
        path: EnumRoutes.landing.root.path,
        name: EnumRoutes.landing.root.name,
        component: () => import('@/views/landing-page/HomePage.vue'),
      },
      {
        path: EnumRoutes.landing.leaderShipDevelopment.path,
        name: EnumRoutes.landing.leaderShipDevelopment.name,
        component: () => import('@/views/landing-page/service/LeaderShip.vue'),
        meta: EnumRoutes.landing.leaderShipDevelopment.meta,
      },
      {
        path: EnumRoutes.landing.executiveCoach.path,
        name: EnumRoutes.landing.executiveCoach.name,
        component: () => import('@/views/landing-page/service/Executive.vue'),
        meta: EnumRoutes.landing.executiveCoach.meta,
      },
      {
        path: EnumRoutes.landing.professional.path,
        name: EnumRoutes.landing.professional.name,
        component: () =>
          import('@/views/landing-page/service/Professional.vue'),
        meta: EnumRoutes.landing.professional.meta,
      },
      {
        path: EnumRoutes.landing.webinars.path,
        name: EnumRoutes.landing.webinars.name,
        component: () => import('@/views/landing-page/service/Webinars.vue'),
        meta: EnumRoutes.landing.webinars.meta,
      },
      {
        path: EnumRoutes.landing.attendanceRules.path,
        name: EnumRoutes.landing.attendanceRules.name,
        component: () => import('@/views/landing-page/AttendanceRules.vue'),
        meta: EnumRoutes.landing.attendanceRules.meta,
      },
      {
        path: EnumRoutes.landing.about.path,
        name: EnumRoutes.landing.about.name,
        component: () => import('@/views/about-us/AboutUs.vue'),
        meta: EnumRoutes.landing.about.meta,
      },
      {
        path: EnumRoutes.landing.privacyPolicy.path,
        name: EnumRoutes.landing.privacyPolicy.name,
        component: () => import('@/views/landing-page/PrivacyPolicy.vue'),
        meta: EnumRoutes.landing.privacyPolicy.meta,
      },
      {
        path: EnumRoutes.landing.refundPolicy.path,
        name: EnumRoutes.landing.refundPolicy.name,
        component: () => import('@/views/landing-page/RefundPolicy.vue'),
        meta: EnumRoutes.landing.refundPolicy.meta,
      },
      {
        path: EnumRoutes.landing.usefulLink.path,
        name: EnumRoutes.landing.usefulLink.name,
        component: () => import('@/views/landing-page/DynamicPage.vue'),
        meta: EnumRoutes.landing.usefulLink.meta,
      },
      {
        name: EnumRoutes.landing.educationEthics.name,
        path: EnumRoutes.landing.educationEthics.path,
        component: () => import('@/views/landing-page/EducationEthics.vue'),
        meta: EnumRoutes.landing.educationEthics.meta,
      },
      {
        name: EnumRoutes.landing.termsOfUse.name,
        path: EnumRoutes.landing.termsOfUse.path,
        component: () => import('@/views/landing-page/TermOfUse.vue'),
        meta: EnumRoutes.landing.termsOfUse.meta,
      },
      {
        path: EnumRoutes.landing.contactUs.path,
        name: EnumRoutes.landing.contactUs.name,
        component: () => import('@/views/landing-page/ContactUs.vue'),
        meta: EnumRoutes.landing.contactUs.meta,
      },
      {
        name: EnumRoutes.landing.technicalSupport.name,
        path: EnumRoutes.landing.technicalSupport.path,
        component: () => import('@/views/landing-page/TechnicalSupport.vue'),
        meta: EnumRoutes.landing.technicalSupport.meta,
      },
      {
        name: EnumRoutes.landing.copyRights.name,
        path: EnumRoutes.landing.copyRights.path,
        component: () => import('@/views/landing-page/CopyRight.vue'),
        meta: EnumRoutes.landing.copyRights.meta,
      },
      {
        name: EnumRoutes.landing.complaints.name,
        path: EnumRoutes.landing.complaints.path,
        component: () => import('@/views/landing-page/ComplaintsPage.vue'),
        meta: EnumRoutes.landing.complaints.meta,
      },
      {
        name: EnumRoutes.guideRoutes.root.name,
        path: EnumRoutes.guideRoutes.root.path,
        component: () => import('@/views/guide/GuidePage.vue'),
        meta: EnumRoutes.guideRoutes.root.meta,
      },
      {
        name: EnumRoutes.guideRoutes.buyACourse.name,
        path: EnumRoutes.guideRoutes.buyACourse.path,
        component: () => import('@/views/guide/GuidePageBuyACourse.vue'),
        meta: EnumRoutes.guideRoutes.buyACourse.meta,
      },
      {
        name: EnumRoutes.guideRoutes.browseACourse.name,
        path: EnumRoutes.guideRoutes.browseACourse.path,
        component: () => import('@/views/guide/GuidePageBrowseACourse.vue'),
        meta: EnumRoutes.guideRoutes.browseACourse.meta,
      },
      {
        name: EnumRoutes.guideRoutes.progress.name,
        path: EnumRoutes.guideRoutes.progress.path,
        component: () => import('@/views/guide/GuidePageProgress.vue'),
        meta: EnumRoutes.guideRoutes.progress.meta,
      },
      {
        name: EnumRoutes.guideRoutes.login.name,
        path: EnumRoutes.guideRoutes.login.path,
        component: () => import('@/views/guide/GuidePageLogin.vue'),
        meta: EnumRoutes.guideRoutes.login.meta,
      },
      {
        name: EnumRoutes.guideRoutes.menu.name,
        path: EnumRoutes.guideRoutes.menu.path,
        component: () => import('@/views/guide/GuidePageMenu.vue'),
        meta: EnumRoutes.guideRoutes.menu.meta,
      },
    ],
  },
];
